__turbopack_context__.v({
  "logo": "w2igXq_logo",
  "rating": "w2igXq_rating",
});
